import { InjectionToken } from '@angular/core';

/** Application Menu Item Injection Token */
export const PRODUCT_LIST_API_LINK_TOKEN: InjectionToken<string> =
  new InjectionToken('PRODUCT_LIST_API_LINK_TOKEN');
